import type { MomentInput } from 'moment'
import moment from 'moment'

export const diffInHours = (date: MomentInput, compareDate: MomentInput) =>
  moment(date).diff(compareDate, 'hours', true)
